import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
// import base64url from 'base64url'
import { fetchBanner } from '../../../actions/mallAction'
import { Swiper } from 'antd-mobile'
// import banner4 from '../../../assets/banner/mall-home-banner-4.png'
// import banner5 from '../../../assets/banner/mall-home-banner-5.png'
// import banner6 from '../../../assets/banner/mall-home-banner-6.png'
// import banner7 from '../../../assets/banner/mall-home-banner-7.png'

// const tempBannerData = [banner6, banner7]

@withRouter
@connect(state => {
  return { store: state.mallBanner }
})
class Banner extends React.PureComponent {
  state = {
    imgHeight: 176
  }

  componentDidMount () {
    const { store, dispatch } = this.props
    if (store.data.length === 0) {
      dispatch(fetchBanner())
    }
  }

  render () {
    const { data } = this.props.store
    return <Swiper
      autoplay
      infinite
      autoplayInterval={5000}
      indicatorProps={{ style: { '--active-dot-color': 'var(--adm-color-primary)', } }}
      style={{ '--track-padding': ' 0 0 8px', }}
    >
      {/*原来的代码*/}
      {data.map(item => {
        return <Swiper.Item key={item.id}
                            onClick={this.toFrame.bind(this, item.link)}
                            style={{ height: this.state.imgHeight }}
        >
          <img alt=''
               src={item.imgUrl}
               style={{ width: '100%', verticalAlign: 'top', height: 'auto' }}
               onLoad={() => {
                 // fire window resize event to change height
                 window.dispatchEvent(new Event('resize'))
                 this.setState({ imgHeight: 'auto' })
               }}
          />
        </Swiper.Item>
      })}
      {/*临时写死的banner，之前要用，现在又改回去了。。*/}
      {/*{*/}
      {/*  tempBannerData.map((img, index) => {*/}
      {/*    return <div*/}
      {/*      key={index}*/}
      {/*      style={{ height: this.state.imgHeight }}>*/}
      {/*      <img alt=''*/}
      {/*        src={img}*/}
      {/*        style={{ width: '100%', verticalAlign: 'top', height: 'auto' }}*/}
      {/*        onLoad={() => {*/}
      {/*          // fire window resize event to change height*/}
      {/*          window.dispatchEvent(new Event('resize'))*/}
      {/*          this.setState({ imgHeight: 'auto' })*/}
      {/*        }}*/}
      {/*      />*/}
      {/*    </div>*/}
      {/*  })*/}
      {/*}*/}
    </Swiper>
  }

  toFrame = (url) => {
    // 暂时去掉这功能
    // if(url) {
    //   this.props.history.push(`${window.PATH.FRAME}/${base64url.encode(url)}`)
    // }
  }
}

export { Banner }

